import PriceE6t from "src/helpers/price";
import ArrowIcon from "src/assets/svg/chevron_right_black.svg";

export const getColumns = (styles, onclickGtmEvent) => [
  {
    key: "roomType",
    title: "Oda Tipi",
    dataIndex: "roomType",
    render: (roomType) => <p className="text-sm font-bold">{roomType}</p>,
  },
  {
    key: "infoMeters",
    title: "M² Bilgisi",
    dataIndex: "infoMeters",
  },
  {
    key: "price",
    title: "Fiyat",
    dataIndex: "price",
    render: (price) => (
      <div className="text-sm font-bold whitespace-nowrap text-ellipsis overflow-hidden">
        {" "}
        <PriceE6t data={price} />
      </div>
    ),
  },
  {
    key: "meterSquarePrice",
    title: "M² Fiyatı",
    dataIndex: "meterSquarePrice",
    render: (price) => (
      <div className="whitespace-nowrap text-ellipsis overflow-hidden">
        {" "}
        <PriceE6t data={price} />/ m²
      </div>
    ),
  },
  {
    key: "cash",
    title: "Peşinat",
    dataIndex: "cash",
    render: (cash) => <span>%{cash}</span>,
  },
  {
    key: "interest",
    title: "Faiz",
    dataIndex: "interest",
    render: (interest) => <span>%{interest}</span>,
  },
  {
    key: "maturity",
    title: "Vade",
    dataIndex: "maturity",
    render: (maturity) => <div className="whitespace-nowrap text-ellipsis overflow-hidden">{`${maturity} Ay`}</div>,
  },
  {
    key: "review",
    title: "",
    dataIndex: "review",
    render: (review) => (
      <div className={styles.tableReviewWrapper}>
        <a className={styles.tableReviewButton} href={review?.hrefUrl} onClick={() => onclickGtmEvent(review)}>
          İncele
        </a>
        <ArrowIcon className="rotate-[270deg]" />
      </div>
    ),
  },
];
